import { useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { baseApiURL } from "../../../baseUrl";
import { FiSearch, FiUpload, FiX } from "react-icons/fi";
import { getFileUrl } from "../../../utils/fileUrl";

const EditFaculty = () => {
  const [file, setFile] = useState();
  const [searchActive, setSearchActive] = useState(false);
  const [data, setData] = useState({
    employeeId: "",
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    department: "",
    batch: "",
    gender: "",
    experience: "",
    post: "",
    panCard: "",
    jntuId: "",
    aicteId: "",
    profile: "",
  });
  const [id, setId] = useState();
  const [search, setSearch] = useState();
  const [previewImage, setPreviewImage] = useState("");

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    const imageUrl = URL.createObjectURL(selectedFile);
    setPreviewImage(imageUrl);
  };

  const updateFacultyProfile = (e) => {
    e.preventDefault();
    toast.loading("Updating Faculty");
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    const formData = new FormData();
    formData.append("employeeId", data.employeeId);
    formData.append("firstName", data.firstName);
    formData.append("middleName", data.middleName);
    formData.append("lastName", data.lastName);
    formData.append("email", data.email);
    formData.append("phoneNumber", data.phoneNumber);
    formData.append("department", data.department);
    if (data.batch) formData.append("batch", data.batch);
    formData.append("experience", data.experience);
    formData.append("gender", data.gender);
    formData.append("post", data.post);
    formData.append("panCard", data.panCard);
    formData.append("jntuId", data.jntuId);
    formData.append("aicteId", data.aicteId);
    if (file) {
      formData.append("type", "profile");
      formData.append("profile", file);
    }
    axios
      .put(`${baseApiURL()}/faculty/details/updateDetails/${id}`, formData, {
        headers: headers,
      })
      .then((response) => {
        toast.dismiss();
        if (response.data.success) {
          toast.success(response.data.message);
          clearSearchHandler();
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        toast.dismiss();
        toast.error(error.response.data.message);
      });
  };

  const searchFacultyHandler = (e) => {
    setSearchActive(true);
    e.preventDefault();
    toast.loading("Getting Faculty");
    const headers = {
      "Content-Type": "application/json",
    };
    axios
      .post(
        `${baseApiURL()}/faculty/details/getDetails`,
        { employeeId: search },
        { headers }
      )
      .then((response) => {
        toast.dismiss();
        if (response.data.user.length === 0) {
          toast.error("No Faculty Found!");
        } else {
          toast.success(response.data.message);
          setId(response.data.user[0]._id);
          setData({
            employeeId: response.data.user[0].employeeId,
            firstName: response.data.user[0].firstName,
            middleName: response.data.user[0].middleName,
            lastName: response.data.user[0].lastName,
            email: response.data.user[0].email,
            phoneNumber: response.data.user[0].phoneNumber,
            post: response.data.user[0].post,
            department: response.data.user[0].department,
            batch: response.data.user[0].batch || "",
            gender: response.data.user[0].gender,
            profile: response.data.user[0].profile,
            experience: response.data.user[0].experience,
            panCard: response.data.user[0].panCard,
            jntuId: response.data.user[0].jntuId,
            aicteId: response.data.user[0].aicteId,
          });
        }
      })
      .catch((error) => {
        toast.dismiss();
        if (error?.response?.data) toast.error(error.response.data.message);
        console.error(error);
      });
  };

  const clearSearchHandler = () => {
    setSearchActive(false);
    setSearch("");
    setId("");
    setPreviewImage();
    setData({
      employeeId: "",
      firstName: "",
      middleName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      department: "",
      batch: "",
      gender: "",
      experience: "",
      post: "",
      panCard: "",
      jntuId: "",
      aicteId: "",
      profile: "",
    });
  };
  return (
    <div className="w-full space-y-6">
      {/* Search Header */}
      <form
        className="flex items-center bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-2 shadow-xs max-w-xl mx-auto"
        onSubmit={searchFacultyHandler}
      >
        <input
          type="text"
          className="px-4 py-2 w-full bg-transparent text-xs font-semibold text-slate-900 dark:text-white placeholder-slate-400 outline-none"
          placeholder="Search by Employee ID..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        {!searchActive ? (
          <button className="p-2 text-indigo-600 dark:text-indigo-400 hover:bg-indigo-50 dark:hover:bg-slate-800 rounded-xl transition cursor-pointer" type="submit">
            <FiSearch className="text-lg" />
          </button>
        ) : (
          <button
            className="p-2 text-rose-600 dark:text-rose-400 hover:bg-rose-50 dark:hover:bg-slate-800 rounded-xl transition cursor-pointer"
            onClick={clearSearchHandler}
            type="button"
          >
            <FiX className="text-lg" />
          </button>
        )}
      </form>

      {search && id && (
        <form
          onSubmit={updateFacultyProfile}
          className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-6 shadow-xs space-y-5 max-w-4xl mx-auto"
        >
          <h3 className="text-sm font-bold text-slate-900 dark:text-white border-l-4 border-indigo-600 pl-3">
            Edit Faculty Profile Details
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <div>
              <label htmlFor="batch" className="block text-xs font-bold text-slate-600 dark:text-slate-400 mb-1">
                Batch Year
              </label>
              <select
                id="batch"
                className="w-full p-2 text-xs border border-slate-200 dark:border-slate-800 rounded-xl bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-white"
                value={data.batch}
                onChange={(e) => setData({ ...data, batch: e.target.value })}
              >
                <option value="">-- Select --</option>
                {Array.from({ length: 8 }).map((_, idx) => {
                  const year = new Date().getFullYear() - idx;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </select>
            </div>

            <div>
              <label htmlFor="firstname" className="block text-xs font-bold text-slate-600 dark:text-slate-400 mb-1">
                First Name *
              </label>
              <input
                type="text"
                id="firstname"
                value={data.firstName}
                onChange={(e) => setData({ ...data, firstName: e.target.value })}
                className="w-full p-2 text-xs border border-slate-200 dark:border-slate-800 rounded-xl bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-white"
              />
            </div>

            <div>
              <label htmlFor="middlename" className="block text-xs font-bold text-slate-600 dark:text-slate-400 mb-1">
                Middle Name
              </label>
              <input
                type="text"
                id="middlename"
                value={data.middleName}
                onChange={(e) => setData({ ...data, middleName: e.target.value })}
                className="w-full p-2 text-xs border border-slate-200 dark:border-slate-800 rounded-xl bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-white"
              />
            </div>

            <div>
              <label htmlFor="lastname" className="block text-xs font-bold text-slate-600 dark:text-slate-400 mb-1">
                Last Name *
              </label>
              <input
                type="text"
                id="lastname"
                value={data.lastName}
                onChange={(e) => setData({ ...data, lastName: e.target.value })}
                className="w-full p-2 text-xs border border-slate-200 dark:border-slate-800 rounded-xl bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-white"
              />
            </div>

            <div>
              <label htmlFor="employeeId" className="block text-xs font-bold text-slate-600 dark:text-slate-400 mb-1">
                Employee ID
              </label>
              <input
                disabled
                type="text"
                id="employeeId"
                value={data.employeeId}
                className="w-full p-2 text-xs border border-slate-200 dark:border-slate-800 rounded-xl bg-slate-100 dark:bg-slate-950 text-slate-500 font-mono"
              />
            </div>

            <div>
              <label htmlFor="phoneNumber" className="block text-xs font-bold text-slate-600 dark:text-slate-400 mb-1">
                Phone Number
              </label>
              <input
                type="tel"
                id="phoneNumber"
                value={data.phoneNumber}
                onChange={(e) => setData({ ...data, phoneNumber: e.target.value })}
                className="w-full p-2 text-xs border border-slate-200 dark:border-slate-800 rounded-xl bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-white"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-xs font-bold text-slate-600 dark:text-slate-400 mb-1">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                value={data.email}
                onChange={(e) => setData({ ...data, email: e.target.value })}
                className="w-full p-2 text-xs border border-slate-200 dark:border-slate-800 rounded-xl bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-white"
              />
            </div>

            <div>
              <label htmlFor="post" className="block text-xs font-bold text-slate-600 dark:text-slate-400 mb-1">
                Designation / Post
              </label>
              <input
                type="text"
                id="post"
                value={data.post}
                onChange={(e) => setData({ ...data, post: e.target.value })}
                className="w-full p-2 text-xs border border-slate-200 dark:border-slate-800 rounded-xl bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-white"
              />
            </div>

            <div>
              <label htmlFor="experience" className="block text-xs font-bold text-slate-600 dark:text-slate-400 mb-1">
                Experience (Years)
              </label>
              <input
                type="text"
                id="experience"
                value={data.experience}
                onChange={(e) => setData({ ...data, experience: e.target.value })}
                className="w-full p-2 text-xs border border-slate-200 dark:border-slate-800 rounded-xl bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-white"
              />
            </div>

            <div>
              <label htmlFor="panCard" className="block text-xs font-bold text-slate-600 dark:text-slate-400 mb-1">
                PAN Card
              </label>
              <input
                type="text"
                id="panCard"
                value={data.panCard}
                onChange={(e) => setData({ ...data, panCard: e.target.value })}
                className="w-full p-2 text-xs border border-slate-200 dark:border-slate-800 rounded-xl bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-white font-mono"
              />
            </div>

            <div>
              <label htmlFor="jntuId" className="block text-xs font-bold text-slate-600 dark:text-slate-400 mb-1">
                JNTU ID
              </label>
              <input
                type="text"
                id="jntuId"
                value={data.jntuId}
                onChange={(e) => setData({ ...data, jntuId: e.target.value })}
                className="w-full p-2 text-xs border border-slate-200 dark:border-slate-800 rounded-xl bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-white"
              />
            </div>

            <div>
              <label htmlFor="aicteId" className="block text-xs font-bold text-slate-600 dark:text-slate-400 mb-1">
                AICTE ID
              </label>
              <input
                type="text"
                id="aicteId"
                value={data.aicteId}
                onChange={(e) => setData({ ...data, aicteId: e.target.value })}
                className="w-full p-2 text-xs border border-slate-200 dark:border-slate-800 rounded-xl bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-white"
              />
            </div>

            <div>
              <label className="block text-xs font-bold text-slate-600 dark:text-slate-400 mb-1">
                Update Profile Photo
              </label>
              <label
                htmlFor="file"
                className="p-2 border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-950 rounded-xl text-xs font-bold flex justify-center items-center gap-1.5 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-700 dark:text-slate-300"
              >
                <FiUpload />
                <span>Upload New Photo</span>
              </label>
              <input
                hidden
                type="file"
                id="file"
                accept="image/*"
                onChange={handleFileChange}
              />
            </div>
          </div>

          {(previewImage || data.profile) && (
            <div className="flex justify-center items-center pt-2">
              <img
                src={getFileUrl(previewImage || data.profile)}
                alt="faculty"
                className="h-28 w-28 rounded-2xl object-cover border border-slate-200 dark:border-slate-800 shadow-xs"
              />
            </div>
          )}

          <div className="flex justify-end pt-2">
            <button
              type="submit"
              className="px-6 py-2.5 bg-indigo-600 hover:bg-indigo-500 text-white font-bold text-xs rounded-xl shadow-xs transition cursor-pointer"
            >
              Update Faculty Member
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default EditFaculty;
